import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import CompressFilesImagesListScreen from "./CompressFilesImagesListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function CompressFilesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Compress Files, Zip Files For Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/compress_files", title: "Create Zip Files For Free" },
    data2: { link: "/compress_files", title: "Reduce File Size (.zip)" },
    data3: { link: "/compress_files", title: "File Compressor" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Compress and zip files online instantly. Reduce file size, save storage, and share documents quickly with our fast, secure file compression tool."
      ></meta>
      <meta
        name="keywords"
        content="file compressor, zip files online, compress files online, reduce file size, online file compressor, file zip tool, compress documents, file shrink tool, document compressor, online file zip, compress large files, file compression tool, zip and compress files, file optimizer, compress files for email"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CompressFilesImagesListScreen
          title={title}
        ></CompressFilesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView selectMultiple={true} allowFolder={true} />
          {/* Mid Section */}
          <MiscPageMidSection description="Our File Compressor website provides a fast, secure, and efficient solution to reduce file sizes without compromising quality, even when there is no internet connection. Built to work fully offline, this powerful tool allows users to compress files directly on their device, ensuring complete privacy and data protection. Whether you need to shrink documents, images, videos, or folders, this offline-ready solution supports multiple formats and delivers optimized compression results. The platform also offers flexible online access, enabling users to use it as a file compressor online or a fully offline utility based on their needs. With intuitive controls, users can quickly zip files, compress files, and bundle multiple items into a single archive. Acting as a reliable online file compressor with offline capabilities, the tool makes it easy to create zip file online or offline for fast sharing, uploading, and storage. Optimized for speed and performance, it reduces file sizes efficiently while maintaining original content quality. Ideal for students, professionals, and businesses, this website is perfect for email attachments, cloud uploads, backups, and file management. If you are looking for a dependable file compressor online, a secure way to compress files, zip files, or create zip file online with offline support, this platform delivers a smooth experience designed for modern file handling needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Compress",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="File Compressor"
            why_use={[
              {
                title: "Reduce File Size for Easy Sharing",
                description:
                  "Our file compressor reduces large file sizes, making it easier to share files via email, messaging apps, or cloud platforms.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Using compress files tools helps free up disk space by shrinking files without affecting usability.",
              },
              {
                title: "Faster Uploads and Downloads",
                description:
                  "Smaller compressed files upload and download faster. Our file compressor online improves transfer speed.",
              },
              {
                title: "Create ZIP Files Easily",
                description:
                  "This file compressor allows users to zip files and combine multiple files into a single archive.",
              },
              {
                title: "Simplify File Organization",
                description:
                  "Creating ZIP archives helps organize files. Tools that create zip file online make file management easier.",
              },
              {
                title: "Offline Compression for Privacy",
                description:
                  "Our offline file compressor processes files locally, ensuring sensitive data remains private and secure.",
              },
              {
                title: "Reduce Bandwidth Usage",
                description:
                  "Using a file compressor online or offline reduces bandwidth consumption during file transfers.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals rely on compress files tools for assignments, reports, and project submissions.",
              },
              {
                title: "Maintain File Quality and Integrity",
                description:
                  "Modern file compressor online tools compress files while preserving original data quality and structure.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I compress files offline?",
                description:
                  "You can use Shivapdf's browser-based compression tool to reduce file sizes locally on your device. Open the tool, select a supported file, choose the available compression settings, and save the compressed file without uploading its contents to a server."
              },
              {
                title: "Can I compress files without uploading them?",
                description:
                  "Yes, Shivapdf processes supported files locally in your browser, so you can compress them without uploading their contents to a remote server. Your files remain on your device during local processing."
              },
              {
                title: "Is this offline file compressor free?",
                description:
                  "Shivapdf provides a browser-based file compression tool that you can use for free, subject to any usage or file size limits displayed on the website."
              },
              {
                title: "Are my files safe when compressed locally?",
                description:
                  "Local file compression helps protect your privacy by processing file contents on your device rather than sending them to a remote server. For sensitive documents, verify that the tool processes files locally and review the website's privacy policy."
              },
              {
                title: "Do I need an internet connection to compress files?",
                description:
                  "You may need an internet connection to open the Shivapdf website initially. If the compression tool and its required resources are available locally, you can process files without an active internet connection."
              },
              {
                title: "Which file formats can I compress?",
                description:
                  "Supported file formats depend on the compression tool you are using. Check the tool's upload area for compatible formats, such as PDF documents or supported image and archive files."
              },
              {
                title: "Can I compress PDF files locally?",
                description:
                  "Yes, you can use a compatible PDF compression tool to reduce PDF file sizes locally in your browser. This lets you process supported PDF documents without uploading their contents to a server."
              },
              {
                title: "Can I compress images without uploading them?",
                description:
                  "Yes, supported image files can be compressed locally using a browser-based image compression tool. This helps reduce image file sizes while keeping the original files on your device."
              },
              {
                title: "Can I compress files without installing software?",
                description:
                  "Yes, Shivapdf offers browser-based tools that let you compress supported files without installing a separate desktop application. Simply open the appropriate tool in your browser and select your file."
              },
              {
                title: "Does local file compression protect my privacy?",
                description:
                  "Local compression helps protect your privacy because the contents of your files are processed on your device instead of being uploaded to a remote server. Website analytics or other services may still make separate network requests."
              },
              {
                title: "Will compressing a file reduce its quality?",
                description:
                  "The effect on quality depends on the file format and compression method. Lossless compression preserves the original data, while lossy compression can reduce file size further by removing some information or image detail."
              },
              {
                title: "How much can I reduce a file's size?",
                description:
                  "The amount of compression depends on the original file, its format, and the compression method. Files containing large images or uncompressed data may offer greater size reductions than files that are already optimized."
              },
              {
                title: "Can I compress large files locally?",
                description:
                  "Yes, if the file format is supported and your device has sufficient memory and processing power. Very large files may take longer to process or exceed your browser's available memory."
              },
              {
                title: "Can I compress files on my mobile phone?",
                description:
                  "Yes, you can use Shivapdf's supported browser-based compression tools on an iPhone, Android phone, or tablet. Performance depends on your device, browser, file format, and file size."
              },
              {
                title: "Will the original file be changed after compression?",
                description:
                  "The compression tool generally creates a compressed output file that you can save separately. Your original file remains unchanged unless you choose to replace or overwrite it yourself."
              },
              {
                title: "Why is my file not getting much smaller?",
                description:
                  "Some files are already compressed or contain data that cannot be reduced significantly. Try an appropriate compression method for the file format, if additional settings are available."
              },
              {
                title: "Can I compress files without creating an account?",
                description:
                  "You can use the compression tool without creating an account if registration is not required by the particular tool. Check the website for any applicable usage restrictions."
              },
              {
                title: "Is offline compression different from online compression?",
                description:
                  "Offline compression processes files without requiring an active internet connection, provided the tool is already available on your device. Browser-based local compression can also work without uploading files, even when an internet connection is required to access the website."
              },
              {
                title: "How do I download a compressed file?",
                description:
                  "After compression finishes, select the download or save option to store the compressed file on your device. Check the resulting file to ensure it opens correctly and meets your size and quality requirements."
              },
              {
                title: "Why should I use a local file compressor?",
                description:
                  "A local file compressor can offer better privacy by keeping file contents on your device, reduce the need to transfer large files over the internet, and provide a convenient way to compress supported files directly in your browser."
              }
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CompressFilesMain;
